import { render, staticRenderFns } from "./relanew.vue?vue&type=template&id=cd014ce2&scoped=true&"
import script from "./relanew.vue?vue&type=script&lang=js&"
export * from "./relanew.vue?vue&type=script&lang=js&"
import style0 from "./relanew.vue?vue&type=style&index=0&id=cd014ce2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd014ce2",
  null
  
)

export default component.exports